const MOCK_DATA = [
  {
    address: '0xf991f1e1b8acd657661c89b5cd452d86de76a8c1',
    infoUrl:
      'https://info.uniswap.org/pair/0x648450d9c30b73e2229303026107a1f7eb639f6c',
    liquidityUrl:
      'https://uniswap.exchange/add/0x1337def16f9b486faed0293eb623dc8395dfe46a/ETH',
    pair: 'eth',
    prefix: 'Armor_aryDAI',
    rewardsAvailable: false,
    title: 'aryDAI',
    asset: 'aryDAI',
  },
  {
    address: '0xf991f1e1b8acd657661c89b5cd452d86de76a8c1',
    infoUrl:
      'https://info.uniswap.org/pair/0x648450d9c30b73e2229303026107a1f7eb639f6c',
    liquidityUrl:
      'https://uniswap.exchange/add/0x1337def16f9b486faed0293eb623dc8395dfe46a/ETH',
    pair: 'eth',
    prefix: 'Armor_aryCRV',
    rewardsAvailable: false,
    title: 'aryCRV',
    asset: 'aryCRV',
  },
]
export default MOCK_DATA
